"use client";
import { useEffect, useState } from "react";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [isAutoRetrying, setIsAutoRetrying] = useState(true);

  useEffect(() => {
    console.error("global-error caught:", error);
    // silent auto-reload up to 2 times - not noticeable
    try {
      const KEY = "spanda_error_reload_count";
      const MAX = 2;
      const EXPIRY = 10 * 60 * 1000;
      const raw = window.sessionStorage.getItem(KEY);
      const data = raw ? (JSON.parse(raw) as { c: number; ts: number }) : { c: 0, ts: Date.now() };
      const expired = Date.now() - data.ts > EXPIRY;
      const count = expired ? 0 : data.c;
      if (count < MAX) {
        window.sessionStorage.setItem(KEY, JSON.stringify({ c: count + 1, ts: expired ? Date.now() : data.ts }));
        const t = window.setTimeout(() => window.location.reload(), 100);
        return () => window.clearTimeout(t);
      } else {
        setIsAutoRetrying(false);
      }
    } catch {
      setIsAutoRetrying(false);
    }
  }, [error]);

  if (isAutoRetrying) {
    return (
      <html>
        <body>
          <div className="flex min-h-screen flex-col items-center justify-center p-8">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-200 border-t-[#13224b]" />
          </div>
        </body>
      </html>
    );
  }

  return (
    <html>
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center p-8 text-center">
          <h2 className="text-2xl font-black">Application error</h2>
          <p className="mt-3 text-sm text-slate-600">An unexpected error occurred.</p>
          <button onClick={() => window.location.reload()} className="mt-6 rounded-full bg-[#13224b] px-6 py-3 text-sm text-white">
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
